module.exports = {
    'Initial Use':'DEVICES.V2.FORM.OPTION.EQUIPMENT_USAGE.INITIAL_USE',
    'Reuse of Single Use Device':'DEVICES.V2.FORM.OPTION.EQUIPMENT_USAGE.REUSE_OF_SINGLE_USE_DEVICE',
    'Reuse of Reusable Device':'DEVICES.V2.FORM.OPTION.EQUIPMENT_USAGE.REUSE_OF_REUSABLE_DEVICE',
    'Re-serviced/Refurbished':'DEVICES.V2.FORM.OPTION.EQUIPMENT_USAGE.RE_SERVICED_REFURBISHED',
    'Other':'DEVICES.V2.FORM.OPTION.EQUIPMENT_USAGE.OTHER'
};
